import { ActivatedRoute } from "@angular/router";
import { Injectable } from "@angular/core";
import {NAVIGATION_ROUTE_MEASUREMENT_ID_PARAM} from "../../tools/navigation/navigation-route";

@Injectable()
export class MeasurementIdProvider {
  constructor() {}

  getId(route: ActivatedRoute): number | undefined {
    const idParam = route.snapshot.paramMap.get(NAVIGATION_ROUTE_MEASUREMENT_ID_PARAM);

    if (idParam === null || isNaN(+idParam)) {
      return undefined;
    }

    return +idParam;
  }
}
